import React from 'react'

interface msgProps{
    msg?: string,
}

export default function Message(props: msgProps) {
  return (
    <div>{props?.msg}</div>
  )
}
